import { render, staticRenderFns } from "./MyExportFile.vue?vue&type=template&id=08dded5a&"
import script from "./MyExportFile.vue?vue&type=script&lang=js&"
export * from "./MyExportFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports